import { dynamicImport } from '@core/helpers'
import { ROUTES } from '@router'

const ModelsComparisonHome = () =>
  dynamicImport(import('./pages/ModelsComparisonHome/ModelsComparisonHome.vue'))
const ModelsComparisonResults = () =>
  dynamicImport(
    import('./pages/ModelsComparisonResults/ModelsComparisonResults.vue'),
  )
const ModelsComparisonSearch = () =>
  dynamicImport(
    import('./pages/ModelsComparisonSearch/ModelsComparisonSearch.vue'),
  )

export default () => {
  return [
    {
      name: ROUTES.MODELS_COMPARISON.HOME,
      path: 'compare/home',
      component: ModelsComparisonHome,
    },
    {
      name: ROUTES.MODELS_COMPARISON.COMPARISON_RESULTS,
      path: 'compare/:productA/:productB',
      component: ModelsComparisonResults,
    },
    {
      name: ROUTES.MODELS_COMPARISON.CATEGORY,
      path: 'compare/:category',
      component: ModelsComparisonSearch,
    },
  ]
}
